import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login.vue';
import Dashboard from './Dashboard.vue';
import store from './store/index';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login,
            props: true,
            meta: {
                guest: true,
            },
        },
        {
            path: '/',
            component: Dashboard,
            meta: {
                requiresAuth: true,
            },
            children: [
                {
                    path: '/api-keys',
                    name: 'api-keys',
                    component: () => import(/* webpackChunkName: "api-keys" */ './views/APIKeys.vue'),
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/route-of-administation',
                    name: 'route-of-administation',
                    component: () => import(/* webpackChunkName: "route-of-administation" */ './views/RouteOfAdministration.vue'),
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/wada-classification',
                    name: 'wada-classification',
                    component: () => import(/* webpackChunkName: "wada-classification" */ './views/WADAClassification.vue'),
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/users',
                    name: 'users',
                    component: () => import(/* webpackChunkName: "users" */ './views/Users.vue'),
                    meta: {
                        requiresAuth: true,
                        admin: true,
                    },
                },
                {
                    path: '/dictionary',
                    name: 'dictionary',
                    component: () => import(/* webpackChunkName: "dictionary" */ './views/Dictionary.vue'),
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/global-notes',
                    name: 'global-notes',
                    component: () => import(/* webpackChunkName: "global-notes" */ './views/GlobalNotes/GlobalNotes.vue'),
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/global-notes/create',
                    name: 'global-notes.create',
                    component: () => import(/* webpackChunkName: "create-global-note" */ './views/GlobalNotes/CreateGlobalNote.vue'),
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/global-notes/:id',
                    name: 'global-notes.single',
                    component: () => import(/* webpackChunkName: "single-global-note" */ './views/GlobalNotes/SingleGlobalNote.vue'),
                    props: true,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/substances',
                    name: 'substances',
                    component: () => import(/* webpackChunkName: "substances" */ './views/Substances/Substances.vue'),
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/substances/create',
                    name: 'substances.create',
                    props: true,
                    component: () => import(/* webpackChunkName: "create-substances" */ './views/Substances/CreateSubstance.vue'),
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/substances/:id',
                    name: 'substances.single',
                    component: () => import(/* webpackChunkName: "single-substances" */ './views/Substances/SingleSubstance.vue'),
                    props: true,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/preparations',
                    name: 'preparations',
                    component: () => import(/* webpackChunkName: "preparations" */ './views/Preparations/Preparations.vue'),
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/preparations/create',
                    name: 'preparations.create',
                    props: true,
                    component: () => import(/* webpackChunkName: "create-preparations" */ './views/Preparations/CreatePreparation.vue'),
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/preparations/:id',
                    name: 'preparations.single',
                    component: () => import(/* webpackChunkName: "single-preparations" */ './views/Preparations/SinglePreparation.vue'),
                    props: true,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/notifications',
                    name: 'notifications',
                    component: () => import(/* webpackChunkName: "notifications" */ './views/Notifications/Notifications.vue'),
                    props: true,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: '/importdata',
                    name: 'importdata',
                    component: () => import(/* webpackChunkName: "importdata" */ './views/Importdata/Importdata.vue'),
                    props: true,
                    meta: {
                        requiresAuth: true,
                    },
                },
            ],
        },
        {
            path: '*',
            name: 'page-not-found',
            component: () => import(/* webpackChunkName: "404" */ './views/404.vue'),
        },
    ],
});

router.beforeEach(async (to, from, next) => {
    const loginScreen = {
        name: 'login',
        query: { url: to.path },
    };

    try {
        if (to.matched.some(record => record.meta.requiresAuth)) {
            let user = store.getters['auth/user'];

            if (!user) {
                user = await store.dispatch('auth/getSelf');
            }

            if (!store.getters['auth/isAuthenticated']) {
                throw Error('Token mangler');
            } else if (to.matched.some(record => record.meta.admin)) {
                if (user.isAdministrator) {
                    store.dispatch('auth/updateLastSeen');
                    next();
                } else {
                    throw Error('Brugeren har ikke adgang til denne sektion.');
                }
            }

            store.dispatch('auth/updateLastSeen');
            next();
        }
    } catch (error) {
        console.error('Router denied access: ', error.message);
        store.dispatch('auth/logout');
        next(loginScreen);
    }

    next();
});

export default router;
